const style = {
  filter: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '14px 15px 8px',

    '& .MuiOutlinedInput-input': {
      padding: '0px 3px 0px 5px',
      fontSize: '10px',
      minWidth: '100px',
      borderRadius: '0px',
      border: '1px solid #7f8fa4',
    },

    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      whiteSpace: 'nowrap',
      transform: 'translate(0px, -13px) scale(0.75)',
      color: '#181c23',
    },

    '& .MuiOutlinedInput-root': {
      borderRadius: '0px',
      height: 'auto',
    },

    '& .MuiSelect-iconOutlined': {
      right: '0px',
    },

    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
  },
}

export default style



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Ambasadors/AmbassadorsPipelineView/components/PipelineColumn/ColumnHeader/PeriodsFilter/style.js